import { ArrowRight, Shield, Sparkles, Zap } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/66b23153-6ac2-423a-b425-4af124f4013d/images/dcf669801daa52f78a883d99656548c3ce7ec68aa7d7b507b90d0fe407a0f0af.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-28 pb-20 sm:pt-36 sm:pb-28"
    >
      {/* Background grid + radial */}
      <div className="absolute inset-0 bg-grid opacity-60" />
      <div className="absolute inset-0 bg-radial-violet" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-violet-500/60 to-transparent" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left text */}
          <div className="lg:col-span-7">
            <div
              className="inline-flex items-center gap-2 rounded-full border border-violet-500/30 bg-violet-500/10 px-3 py-1 text-xs font-mono uppercase tracking-[0.18em] text-violet-300"
              data-testid="hero-badge"
            >
              <Sparkles className="h-3.5 w-3.5" />
              Atelier indépendant · Paris
            </div>

            <h1
              data-testid="hero-title"
              className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]"
            >
              Votre PC Gaming{" "}
              <span className="text-violet-400 text-glow-violet">
                monté par un passionné
              </span>{" "}
              — livré, testé,{" "}
              <span className="relative inline-block">
                <span className="relative z-10">prêt à jouer.</span>
                <span className="absolute -bottom-1 left-0 right-0 h-2 bg-violet-500/30 blur-sm" />
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-zinc-400 text-base sm:text-lg leading-relaxed">
              Pose seule ou PC clé en main : devis écrit, prix bloqué, câblage
              irréprochable et tests poussés avant livraison. Zéro mauvaise
              surprise.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                data-testid="hero-cta-quote"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-violet-600 hover:bg-violet-500 px-6 py-3 text-sm font-semibold text-white shadow-violet transition-all hover:-translate-y-0.5"
              >
                Demander un devis gratuit
                <ArrowRight className="h-4 w-4" />
              </a>
              <a
                href="#services"
                data-testid="hero-cta-services"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-white/10 bg-white/5 hover:bg-white/10 px-6 py-3 text-sm font-semibold text-white transition-all"
              >
                Découvrir les services
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 sm:gap-8 max-w-md">
              <div>
                <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                  À partir de
                </dt>
                <dd className="mt-1 font-display text-2xl font-bold text-white">
                  80€
                </dd>
              </div>
              <div>
                <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                  Délai
                </dt>
                <dd className="mt-1 font-display text-2xl font-bold text-white">
                  24–72h
                </dd>
              </div>
              <div>
                <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                  Prix
                </dt>
                <dd className="mt-1 font-display text-2xl font-bold text-violet-400">
                  garanti
                </dd>
              </div>
            </dl>
          </div>

          {/* Right image */}
          <div className="lg:col-span-5 relative">
            <div className="relative gradient-border rounded-2xl p-2 shadow-violet-soft float">
              <div className="relative overflow-hidden rounded-xl scan-line">
                <img
                  src={HERO_IMG}
                  alt="PC gaming custom signé ZFIndustries"
                  className="w-full h-full object-cover"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-violet-900/20 via-transparent to-cyan-400/10 mix-blend-screen" />
              </div>

              {/* Floating chips */}
              <div className="absolute -bottom-4 -left-4 flex items-center gap-2 rounded-full border border-white/10 bg-black/80 px-3 py-1.5 backdrop-blur">
                <Shield className="h-3.5 w-3.5 text-violet-400" />
                <span className="text-[11px] font-mono uppercase tracking-wider">
                  Prix garanti
                </span>
              </div>
              <div className="absolute -top-4 -right-4 flex items-center gap-2 rounded-full border border-white/10 bg-black/80 px-3 py-1.5 backdrop-blur">
                <Zap className="h-3.5 w-3.5 text-cyan-300" />
                <span className="text-[11px] font-mono uppercase tracking-wider">
                  Stress-tested
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
